import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'home',
        component: HomeView,
        meta: { title: '首页' }
    },
    // 关于我们
    {
        path: '/about',
        name: 'about',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/AboutView.vue')
    },
    {
        path: '/newpage',
        name: 'newpage',
        meta: { title: '新闻列表' },
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/newpage.vue')
    },
    {
        path: '/newsDetail',
        name: 'newsDetail',
        meta: { title: '新闻详情' },
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/newsDetail.vue')
    },

    {
        path: '/contactus',
        name: 'contactus',
        meta: { title: '联系我们' },
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/contactus.vue')
    },

    { path: '*', redirect: "/home" },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
export default router